interface SetFieldParams {
  name: string
  value: any
}

export class RuntimeStorageManager {
  storage: Record<string, any>

  constructor() {
    window.tokenStorage = {}

    this.storage = window.tokenStorage
  }

  removeFieldFromStorage(name: string): void {
    // eslint-disable-next-line no-prototype-builtins
    if (this.storage.hasOwnProperty(name)) {
      delete this.storage[name]
    }
  }

  setFieldInStorage({ name, value }: SetFieldParams): void {
    this.storage[name] = value
  }

  getFieldFromStorage(name: string): any {
    return this.storage[name]
  }
}
